import "./globalStyles/index.scss";
import { Provider } from "react-redux";
import store from "./redux/store";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import LayoutPage from "./pages/LayoutPage";
import { RoutesEnum } from "./tsmodels/RoutesModel";
import { ToastContainer } from "react-toastify";
import QuestionnaireListPage from "./pages/QuestionnaireListPage";
import DocumentsListPage from "./pages/DocumentsListPage";
import MappingsListPage from "./pages/MappingsListPage";
import QuestionnaireDetailsPage from "./pages/QuestionnaireDetailsPage";
import DocumentsCreateNewPage from "./pages/DocumentsCreateNewPage";
import DocumentsDetailsPage from "./pages/DocumentsDetailsPage";
import MappingsDetailsPage from "./pages/MappingsDetailsPage";
import NotFoundPage from "./pages/NotFoundPage";
import QuestionnairePage from "./pages/QuestionnairePage";

const router = createBrowserRouter([
  // pages with sidebar
  {
    path: RoutesEnum.BASIC,
    element: <LayoutPage sidebar />,
    children: [
      {
        path: RoutesEnum.BASIC,
        element: <DocumentsCreateNewPage />
      },
      { 
        path: RoutesEnum.QUESTIONNAIRE, 
        element: <QuestionnaireListPage />,
      },
      { 
        path: RoutesEnum.DOCUMENTS, 
        element: <DocumentsListPage />,
      },
      { 
        path: RoutesEnum.MAPPINGS, 
        element: <MappingsListPage />,
      },
      {
        path: RoutesEnum.CREATE_NEW,
        element: <DocumentsCreateNewPage />
      },
    ],
  },
  // pages without sidebar
  {
    path: RoutesEnum.BASIC,
    element: <LayoutPage />,
    children: [
      { 
        path: RoutesEnum.QUESTIONNAIRE, 
        children: [
          {
            path: `${RoutesEnum.CATEGORIES}/:questionnaireName/:questionnaireId`,
            element: <QuestionnairePage />,
          },
        ]
      },
      { 
        path: RoutesEnum.DOCUMENTS, 
        children: [
          {
            path: `${RoutesEnum.DETAILS}/:documentId`,
            element: <DocumentsDetailsPage />
          }
        ]
      },
      { 
        path: RoutesEnum.MAPPINGS, 
        children: [
          {
            path: `${RoutesEnum.DETAILS}/:mappingId`,
            element: <MappingsDetailsPage />
          }
        ]
      }
    ],
  },
  // rest all the routes are redirected to notfound
  {
    path: RoutesEnum.ALL,
    element: <LayoutPage />,
    children: [
      { path: RoutesEnum.ALL, element: <NotFoundPage /> }
    ]
  },
]);

function App() {
  return (
    <div className="App header">
      <Provider store={store}>
        <RouterProvider router={router} />
        <ToastContainer />
        
      </Provider>
    </div>
  );
}

export default App;
